function at(n) {
    n = Math.trunc(n) || 0;
    if (n < 0) n += this.length;
    if (n < 0 || n >= this.length) return undefined;
    return this[n];
}

function findLast(fn) {
    return this.filter(fn).at(-1);
}

function applyPolyfill() {
    for (const C of [Array]) {
        Object.defineProperty(C.prototype, "at", {
            value: at,
            writable: true,
            enumerable: false,
            configurable: true
        });

        Object.defineProperty(C.prototype, "findLast", {
            value: findLast,
            writable: true,
            enumerable: false,
            configurable: true
        });
    }
}

export default applyPolyfill;
